module.exports = __webpack_public_path__ + "img/b4.49ddb1ea.png";